import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { outlookIntegrationsQuery } from "modules/settings/lib/outlook/outlookIntegrationsQuery"

export function useDeleteOutlookIntegrationMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id }: { id: string }) => {
      await axios.delete(`/integrations/outlook/${id}`)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: outlookIntegrationsQuery().queryKey })
    },
  })
}
